import axios from 'axios'

import type { components, operations } from '../constants/schema'

type GetQnaListParams = Required<operations['QnaController_findAll']['parameters']>['query']
type GetQnaChatsParams = Required<operations['QnaController_findChats']['parameters']>['query']

/**
 * 로그인 유저 QnA 목록
 * @param size call 한 번에 불러오는 개수
 * @param offset pagination
 * @param title QnA 제목
 * @returns ResListQna
 */
export const getQnaList = async ({ size = 50, offset = 0, title }: GetQnaListParams) => {
  return (await axios.get<components['schemas']['ResListQna']>('/user/qna', { params: { size, offset, title } })).data
}

/**
 * 로그인 유저 QnA 상세
 * @param qnaId QnA id
 * @returns QnaDto
 */
export const getQnaDetail = async (qnaId: number) => {
  return (await axios.get<components['schemas']['QnaDto']>(`/user/qna/${qnaId}`)).data
}

/**
 * 로그인 유저 QnA 등록
 * @param data QnaCreateDto
 * @returns QnaDto
 */
export const registerQna = async (data: components['schemas']['QnaCreateDto']) => {
  try {
    return (await axios.post<components['schemas']['QnaDto']>('/user/qna', data)).data
  } catch (error) {
    throw error
  }
}

/**
 * 로그인 유저 QnA 메시지 목록
 * @param qnaId QnA id
 * @param size call 한 번에 불러오는 개수
 * @param offset pagination
 * @param content 문의 내용
 * @returns ResListQnaChat
 */
export const getQnaChats = async (qnaId: number, { size = 50, offset = 0, content }: GetQnaChatsParams) => {
  return (
    await axios.get<components['schemas']['ResListQnaChat']>(`/user/qna/${qnaId}/chats`, {
      params: { size, offset, content },
    })
  ).data
}

/**
 * 로그인 유저 QnA 메시지 등록
 * @param qnaId QnA id
 * @param data QnaChatCreateDto
 * @returns QnaChatDto
 */
export const registerQnaChats = async ({
  qnaId,
  data,
}: {
  qnaId: number
  data: components['schemas']['QnaChatCreateDto']
}) => {
  try {
    return (await axios.post<components['schemas']['QnaChatDto']>(`/user/qna/${qnaId}/chats`, data)).data
  } catch (error) {
    throw error
  }
}
